import { 
  GET_OEM_PARTNER_REQUEST, 
  GET_OEM_PARTNER_SUCCESS, 
  GET_OEM_PARTNER_FAILURE,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE
} from '../constants/oemConstants';

export const getOemPartnerRequest = (id) => ({
  type: GET_OEM_PARTNER_REQUEST,
  payload: id,
});

export const getOemPartnerSuccess = (data) => ({
  type: GET_OEM_PARTNER_SUCCESS,
  payload: data,
});

export const getOemPartnerFailure = (error) => ({
  type: GET_OEM_PARTNER_FAILURE,
  payload: error,
});

export const sendEmailRequest = (emailData) => ({
  type: SEND_EMAIL_REQUEST,
  payload: emailData,
});

export const sendEmailSuccess = (data) => ({
  type: SEND_EMAIL_SUCCESS,
  payload: data,
});

export const sendEmailFailure = (error) => ({
  type: SEND_EMAIL_FAILURE,
  payload: error,
});